// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (max-width:1263px)and (min-width:960px){.container[data-v-1cb83410]{max-width:980px}}", ""]);
// Exports
module.exports = exports;
